export default {
	isLoading(state) {
		return Boolean(state.loading);
	},

	isMobile(state) {
		return Boolean(state.mobile);
	},
};
